import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba1586d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-newsletter" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col--12 col-md--6" }
const _hoisted_4 = { class: "col--12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDropdown = _resolveComponent("BaseDropdown")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BaseDropdown, {
              label: 'How did you find out about us?',
              placeholder: 'Select an option',
              name: "referer",
              hasError: _ctx.v$.referer.$error,
              errors: _ctx.v$.referer.$errors,
              valid: !_ctx.v$.referer.$invalid,
              modelValue: _ctx.v$.referer.$model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.referer.$model) = $event)),
              options: _ctx.refererOptions
            }, null, 8, ["hasError", "errors", "valid", "modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_BaseCheckbox, {
              id: 'newsletter',
              name: 'newsletter',
              label: 'Tick here to join our e-newsletter to receive special offers, news and updates',
              hasError: _ctx.v$.subscribe.$error,
              errors: _ctx.v$.subscribe.$errors,
              valid: !_ctx.v$.subscribe.$invalid,
              modelValue: _ctx.v$.subscribe.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.subscribe.$model) = $event))
            }, null, 8, ["hasError", "errors", "valid", "modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}